<template>
  <button
    class="sidebar-minibar"
    type="button"
    @click="onClick()" />
</template>
<script>
import { togglePs } from "../../mixins/togglePs";

export default {
  mixins: [togglePs],
  mounted: function() {
    const isMinimized = document.body.classList.contains("sidebar-minimized");
    this.togglePs(!isMinimized);
  },
  methods: {
    onClick() {
      this.sidebarMinimize();
      this.brandMinimize();
    },
    sidebarMinimize() {
      const isMinimized = document.body.classList.toggle("sidebar-minimized");
      this.$emit("cui-sidebar-minimize", isMinimized);
      this.togglePs(!isMinimized);
    },
    brandMinimize() {
      document.body.classList.toggle("brand-minimized");
    }
  }
};
</script>
